var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58004 2.81492C10.8827 1.39893 13.1175 1.39893 14.4202 2.81492L20.0528 8.93733C20.9835 9.94899 21.5001 11.2735 21.5001 12.6481V17.5149C21.5001 19.7347 19.7007 21.5342 17.4809 21.5342H14.9232C13.7124 21.5342 12.7309 20.5526 12.7309 19.3419V16.4188H11.2694V19.3419C11.2694 20.5526 10.2878 21.5342 9.07704 21.5342H6.51935C4.29959 21.5342 2.50012 19.7347 2.50012 17.5149V12.6481C2.50012 11.2735 3.0167 9.94899 3.94742 8.93733L9.58004 2.81492ZM12.8068 4.29923C12.3726 3.82724 11.6277 3.82724 11.1934 4.29923L5.56081 10.4216C5.00238 11.0286 4.69243 11.8233 4.69243 12.6481V17.5149C4.69243 18.5239 5.51037 19.3419 6.51935 19.3419H9.07704V16.4188C9.07704 15.208 10.0586 14.2265 11.2694 14.2265H12.7309C13.9417 14.2265 14.9232 15.208 14.9232 16.4188V19.3419H17.4809C18.4899 19.3419 19.3078 18.5239 19.3078 17.5149V12.6481C19.3078 11.8233 18.9979 11.0286 18.4394 10.4216L12.8068 4.29923Z",
    fill: "#798797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.acf60767b23d23b4cb07a81c2296eb8e.svg";
export { ForwardRef as ReactComponent };